import { useStore, selectReady, selectCreature, selectInWorld, selectInExpedition } from '@/infra/store';
import { ErrorBoundary } from './error/ErrorBoundary';
import { SplashScreen } from './SplashScreen';
import { HouseHud } from './house/HouseHud';
import { WorldHud } from './world/WorldHud';
import { ExpeditionHud } from './expedition/ExpeditionHud';
import { OnboardingOverlay } from './onboarding/OnboardingOverlay';
import { ToastQueue } from './notifications/ToastQueue';
import { KonamiCat } from './easter-egg/KonamiCat';
import { isCreatureGalleryDebugMode } from '@/dev/debug-mode';

export function AppRoot() {
  const ready = useStore(selectReady);
  const creature = useStore(selectCreature);
  const inWorld = useStore(selectInWorld);
  const inExpedition = useStore(selectInExpedition);
  const cbMode = useStore((s) => s.settings.accessibility.colorblindMode);
  const creatureGalleryDebug = isCreatureGalleryDebugMode();
  const filter = cbMode === 'deutero' ? 'url(#cb-deutero)' : undefined;
  return (
    <ErrorBoundary>
      {!ready && <SplashScreen />}
      <div style={{ filter, position: 'fixed', inset: 0, pointerEvents: 'none' }}>
        <div style={{ position: 'relative', width: '100%', height: '100%', pointerEvents: 'auto' }}>
          {ready && creature && !creatureGalleryDebug && !inWorld && !inExpedition && <HouseHud />}
          {ready && creature && !creatureGalleryDebug && inWorld && !inExpedition && <WorldHud />}
          {ready && creature && !creatureGalleryDebug && inExpedition && <ExpeditionHud />}
        </div>
      </div>
      <ToastQueue />
      <KonamiCat />
      {ready && creature && !creatureGalleryDebug && <OnboardingOverlay />}
      {/* SVG filter for colorblind mode */}
      <svg style={{ position: 'fixed', width: 0, height: 0 }} aria-hidden="true">
        <defs>
          <filter id="cb-deutero">
            <feColorMatrix
              type="matrix"
              values="0.625 0.375 0 0 0  0.7 0.3 0 0 0  0 0.3 0.7 0 0  0 0 0 1 0"
            />
          </filter>
        </defs>
      </svg>
    </ErrorBoundary>
  );
}
